module.exports = __webpack_public_path__ + "static/media/jus.37da61ba.svg";